module.exports = __webpack_public_path__ + "static/img/Vibrators-nav-tile-900x1200.37a7cc5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/fenlei/Vibrators-nav-tile-900x1200.jpg
// module id = cFQt
// module chunks = 0